const courseSettings = {
  language: "sv",
  name: "Grund- och fortsättningskurs i programmering 2026",
  siteUrl: "https://programmering-26.mooc.fi",
  githubUrl: "https://github.com/rage/ohjelmointi-26-sv",
  subtitle: "Introduktion till programmering med Python",
  slug: "programmering-26",
  organizationName: "MOOC",
  tmcCourse: "programmering-26",
  quizzesId: "491beba3-d4e3-4700-bd7d-2f1d43a39aa1",
  tmcOrganization: "mooc",
  bannerPath: "banner.svg",
  showExerciseDescriptionWhenNotLoggedIn: true,
  // courseVariants: [
  //   {
  //     tmcOrganization: "laurea",
  //     tmcCourse: "python-2024-stenberg"
  //   },
  //   {
  //     tmcOrganization: "hellu",
  //     tmcCourse: "HelluTTK01"
  //   },
  // ],
}

module.exports = courseSettings
